var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 174,
    viewBox: "0 0 374 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    id: "path-s",
    d: "M372.312 50.2141C374.427 60.8919 371.289 72.1076 363.759 83.2594C356.228 94.4124 344.313 105.485 328.915 115.857C298.119 136.6 253.429 154.516 202.145 164.674C150.862 174.833 102.717 175.306 66.3388 167.868C48.1491 164.149 32.9138 158.455 21.6998 151.015C10.4869 143.575 3.31042 134.403 1.19536 123.725C-0.919711 113.047 2.2182 101.832 9.74859 90.6797C17.2797 79.5267 29.1939 68.4546 44.5924 58.0824C75.3884 37.3387 120.078 19.4232 171.362 9.2649C222.646 -0.893416 270.79 -1.36661 307.169 6.07119C325.358 9.7902 340.594 15.4845 351.808 22.9244C363.02 30.3636 370.197 39.5362 372.312 50.2141Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.5580b48e.svg";
export { ForwardRef as ReactComponent };